// Import model
import { DataviewWasteFactorResponse } from '../models/DataviewWasteFactorResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterWasteFactorRequest } from '../models/FilterWasteFactorRequest';
import { WasteFactor } from '../models/WasteFactor';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterWasteFactorRequestSerializer } from './FilterWasteFactorRequestSerializer';
import { WasteFactorSerializer } from './WasteFactorSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewWasteFactorResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewWasteFactorResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewWasteFactorResponse instance
   */
  static deserialize(json: string): DataviewWasteFactorResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewWasteFactorResponse instance
   */
  static fromObject(obj: any): DataviewWasteFactorResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewWasteFactorResponse');
    }


    const instance: DataviewWasteFactorResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        WasteFactorSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterWasteFactorRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewWasteFactorResponse instances
   */
  static deserializeArray(json: string): DataviewWasteFactorResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewWasteFactorResponse instance to a JSON string
   */
  static serialize(instance: DataviewWasteFactorResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewWasteFactorResponse instance to a plain object
   */
  static toObject(instance: DataviewWasteFactorResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        WasteFactorSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterWasteFactorRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewWasteFactorResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewWasteFactorResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
